<div class="dialog">
    <h6 class="text-center">Reason for Rejection</h6>
    <div class="content">
        <div class="row">
            <mat-checkbox class="col-md-4" (change)="radioChange($event)" value="0" color="warn"><span class="label">Capacity Full</span></mat-checkbox>
            <mat-checkbox class="col-md-4" (change)="radioChange($event)" value="1" color="warn"><span class="label">Rate Discrepancy</span></mat-checkbox>
            <mat-checkbox class="col-md-4" (change)="radioChange($event)" value="2" color="warn"><span class="label">Material Shortage</span></mat-checkbox>
        </div>
        <div class="row mt-2">
            <mat-checkbox class="col-md-4" (change)="radioChange($event)" value="3" color="warn"><span class="label">Technical Difficulties</span></mat-checkbox>
            <mat-checkbox class="col-md-4" (change)="radioChange($event)" value="4" color="warn"><span class="label">Order out of Scope</span></mat-checkbox>
            <mat-checkbox class="col-md-4" (change)="radioChange($event)" value="5" color="warn"><span class="label">Not Interested</span></mat-checkbox>
        </div>
        <div class="row mt-2">
            <mat-checkbox class="col-md-4" (change)="radioChange($event)" value="6" color="warn"><span class="label">Other</span></mat-checkbox>
        </div>
        <div class="input custom-form mt-2">
            <input type="text" (keyup)="inputField($event.target.value)" [disabled]="otherReasons">
        </div>
        <div class="row button mt-3">
            <button class="grey mr-2" (click)="close()">Cancel</button>
            <button class="orange ml-2" (click)="submit()">Confirm</button>
        </div>

    </div>
</div>